import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { ModalComponent } from '../../../components/modal/modal.component';
import { FamilyService } from '../family.service';
import { Family } from '../../../models/family.model';
import { CreateFamilyComponent } from '../create-family/create-family.component';

@Component({
  selector: 'app-list-family',
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    FormsModule,
    ModalComponent,
    CreateFamilyComponent,
    PaginatorModule
  ],
  templateUrl: './list-family.component.html'
})
export class ListFamilyComponent implements OnInit {
  familyId: number | null = null;
  searchTerm = '';
  totalRecords = 0;
  families: Family[] = [];
  loading = false;
  formVisible = false;
  first = 0;
  rows = 5;
  currentPage = 1;

  constructor(private location: Location, private familyService: FamilyService) {}

  ngOnInit(): void {
    this.getData();
  }

  closeModal(): void {
    this.familyId = null;
  }

  getData(): void {
    this.loading = true;
    this.familyService.getAll(this.searchTerm, null, this.currentPage, true).subscribe({
      next: (res) => {
        this.families = res.data ?? [];
        this.totalRecords = res.pagination?.totalRecords ?? 0;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  onPageChange(event: { first?: number }): void {
    this.first = event.first ?? 0;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.getData();
  }

  createFamily(): void {
    this.familyId = null;
    this.changeModal();
  }

  onFormSubmit(): void {
    this.changeModal();
    this.getData();
  }

  changeModal(): void {
    this.formVisible = !this.formVisible;
  }

  edit(family: Family): void {
    this.familyId = family.id;
    this.changeModal();
  }

  remove(family: Family): void {
    if (!confirm(`Deseja inativar a família #${family.id}?`)) {
      return;
    }

    this.familyService.delete(family.id).subscribe({
      next: () => this.getData()
    });
  }

  goBack(): void {
    this.location.back();
  }
}
